<template>
  <div>
    <ValidationObserver ref="formModalValidate">
      <ValidationProvider name="gsmNo" rules="required" v-slot="{ errors }">
        <b-form-group label="Phone Number">
            <PhoneNumberInput
                v-model="mobile_tel"
                :validate-error="errors[0]"
                :defaultCountryCode="studentData.countryCodeForm"
                @update="mobileTelUpdated"
            ></PhoneNumberInput>
        </b-form-group>
      </ValidationProvider>
      <b-button type="submit" @click="sendVerificationSms" variant="primary" class="mr-3">
        {{ $t('next') }}
      </b-button>
    </ValidationObserver>
  </div>
</template>
<script>
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import PhoneNumberInput from "@/components/elements/PhoneNumberInput.vue";

export default {
  data() {
    return {
      phone: null,
      smsTimer: null,
      smsCode: null,
      isLoading: false,
      iso2: null,
      mobile_tel: null,
      form: null
    }
  },
  components: {PhoneNumberInput},
  computed: {
    studentData() {
      return JSON.parse(localStorage.getItem('enrollmentFormData'))
    }
  },
  methods: {
    async sendVerificationSms() {
      const config = {
        mobile_tel: this.mobile_tel
      }
      const res = await EnrollmentAgreementForm.verifyMobileTel(config)
      if (res.data.success) {
        this.$emit('closeVerificationModal', true)
        this.$emit('showVerifyModal', {
          mobile_tel: this.mobile_tel,
          student_data: this.form
        })
      }
    },
    async clearForm() {
      await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
    },
    mobileTelUpdated(event) {
      this.form.mobile_tel = event.nationalNumber;
      this.form.mobile_tel_country_code = '+' + event.countryCallingCode
    }
  },
  created() {
    this.form = {...this.studentData}
    this.mobile_tel = (this.form.mobile_tel_country_code ?? '') + (this.form.mobile_tel ?? '')
  }
};
</script>
